<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>

export default {
  name: 'app',
  data () {
    return {
      height: '56px',
      navH: '58px',
      sibH: 0
    }
  }
}
</script>

<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
  height: 100%;
}

body, html {
  height: 100vh;
}

html {
  scroll-behavior: smooth;
}

h3::before {
  height: 58px;
  content:"";
  display:block;
}

#top::before {
  height: 57px;
  content:"";
  display:block;
}

</style>
